import { VoxelGridCalculator } from '../../../../utils/voxel-grid-calculator';
import { calculateBoundingBox } from '../../../../engine/helpers';

/**
 * Resolution to voxel number mapping
 */
const RESOLUTION_VOXEL_MAP: Record<string, number> = {
  'Low': 600000,
  'Medium': 2500000,
  'High': 10000000
};

/**
 * Calculates the minimum feature size based on resolution and design objects
 * @param resolution - Resolution quality ('Low', 'Medium', 'High')
 * @param designObjects - Array of design objects with groups
 * @returns Calculated feature size in mm
 */
export function calculateMinimumFeatureSize(
  resolution: string,
  designObjects: Array<{ group: any }>
): number {
  const voxNum = RESOLUTION_VOXEL_MAP[resolution] || RESOLUTION_VOXEL_MAP['Low'];
  const bboxDesign = calculateBoundingBox(designObjects.map((o) => o.group));
  const feSize = Number.parseFloat(
    (VoxelGridCalculator.getFeatureSize(bboxDesign, 3, voxNum) * 0.8).toFixed(2)
  );

  return feSize;
}

/**
 * The longest voxel edge of the optimizer's grid over the design objects
 * @param resolution - Resolution quality ('Low', 'Medium', 'High')
 * @param designObjects - Array of design objects with groups
 * @param userDefinedResolution - Optional custom voxel-count override
 * @returns Voxel edge in mm
 */
export function calculateVoxelEdge(
  resolution: string,
  designObjects: Array<{ group: any }>,
  userDefinedResolution?: { enabled: boolean; value: number }
): number {
  const voxNum =
    userDefinedResolution?.enabled && userDefinedResolution.value > 0
      ? userDefinedResolution.value
      : RESOLUTION_VOXEL_MAP[resolution] || RESOLUTION_VOXEL_MAP['Low'];
  const bboxDesign = calculateBoundingBox(designObjects.map((o) => o.group));
  return VoxelGridCalculator.getVoxelEdge(bboxDesign, 3, voxNum);
}
